import React, { PureComponent } from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'

import Fade from '@material-ui/core/Fade'
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import Close from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'

import * as popoverModule from 'modules/popover'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  modalWrapper: {
    outline: 'none',
    maxWidth: '80%',
    maxHeight: '90%',
    margin: '0 auto',
    position: 'relative',
    "& p:not([class^='MuiFormHelperText'])": {
      fontSize: '16px',
      lineHeight: '22px',
    },
    paddingBottom: theme.spacing(4),
    padding: theme.spacing(8) - theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      '& h2': {
        paddingRight: theme.spacing(4),
      },
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  closeButton: {
    width: 56,
    height: 56,
    position: 'absolute',
    top: -theme.spacing(3),
    right: -theme.spacing(3),
    boxShadow: '0px 4px 5px rgba(0,0,0,0.2)',
    backgroundColor: theme.palette.tertiary.main,
    [theme.breakpoints.down('xs')]: {
      top: theme.spacing(2),
      right: theme.spacing(2),
    },
    '&:hover': {
      backgroundColor: theme.palette.tertiary.dark,
    },
  },
  closeIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: theme.palette.white,
  },
})

class PopoverContainer extends PureComponent {
  static displayName = 'Popover';

  static propTypes = {
    data: PropTypes.any,
    actions: PropTypes.object,
    open: PropTypes.bool.isRequired,
    componentName: PropTypes.string,
    classes: PropTypes.object.isRequired,
  };

  static defaultProps = {
    componentName: undefined,
  };

  getContentComponent = (popover) => {
    if (popoverModule[popover]) {
      return popoverModule[popover][1]
    }
    return null
  };

  handleOnClose = () => {
    this.props.actions.hidePopover()
  };

  render() {
    const {
      actions, classes, data, open, componentName
    } = this.props

    const ContentComponent = this.getContentComponent(componentName)

    return (
      <Modal
        open={open}
        onClose={data.onClose || this.handleOnClose}
        className={classes.root}>
        <Fade in={open}>
          <Paper className={classes.modalWrapper}>
            {!data.hideCloseButton && (
              <IconButton
                className={classes.closeButton}
                onClick={this.handleOnClose}
                aria-label="Close">
                <Close className={classes.closeIcon} />
              </IconButton>
            )}
            {ContentComponent && (
              <ContentComponent
                actions={actions}
                data={data}
                handleClose={this.handleOnClose}
              />
            )}
          </Paper>
        </Fade>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    open: idx(state, _ => _.popovers.open),
    data: idx(state, _ => _.popovers.data) || {},
    componentName: idx(state, _ => _.popovers.componentName),
  }
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, popoverModule)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const PopoverComponent = withStyles(styles)(PopoverContainer)
export default connect(mapStateToProps, mapDispatchToProps)(PopoverComponent)



// WEBPACK FOOTER //
// ./src/containers/PopoverContainer.js